import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useQueryParams, NumberParam, StringParam, BooleanParam } from 'use-query-params';
import useSetCredential from "../graphql/hooks/mutations/useSetCredential";
import useViewer from "./useViewer";
import { GET_VIEWER } from "./useGetViewer";
import useDeleteCredential from "../graphql/hooks/mutations/useDeleteCredential";

const useTokenLogin = () => {
  const [ checked, setChecked ] = useState(false);

  const viewer = useViewer();

  // Handle accessToken from the report links
  const [ setCredential ] = useSetCredential();
  const [{
    expiry,
    uid,
    client,
    tokenType,
    accessToken,
  }, setQuery] = useQueryParams({
    expiry: NumberParam,
    uid: StringParam,
    client: StringParam,
    tokenType: StringParam,
    accessToken: StringParam,

    // those arguments won't be used but are set when go through the "Forgotten password"
    // process. We reference them here so we can set them to undefined later.
    token: StringParam,
    client_id: StringParam,
    config: StringParam,
    reset_password: BooleanParam
  });

  const [ deleteCredential ] = useDeleteCredential();
  // We assume that when the token changes, every other value changes
  // it makes things easier and should never be a problem.
  useEffect(() => {
    if (!isEmpty(accessToken)) {
      // We remove those params from the URL so nothing turns bad when
      // people share the link around after they go on the page
      setQuery({
        expiry: undefined,
        uid: undefined,
        client: undefined,
        tokenType: undefined, 
        accessToken: undefined,

        token: undefined,
        client_id: undefined,
        config: undefined,
        reset_password: undefined
      });

      deleteCredential();
      setCredential({
        variables: {
          expiry,
          uid,
          client,
          tokenType: tokenType || 'Bearer',
          accessToken
        }
      });

      // it makes things way easier to reload the page to
      // make sure everything is correctly loaded and working
      document.location.reload();
    }

    setChecked(true);
  }, [ accessToken ]);

  return ({ checked });
}

export default useTokenLogin;
